import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withNamespaces } from 'react-i18next';
import LoadingLayer from '../controls/LoadingLayer';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import IconButton from '@material-ui/core/IconButton';
import FolderIcon from '@material-ui/icons/Folder';

import * as StatusCode from '../../scripts/StatusCode';
import * as StatusSurvey from '../../scripts/StatusSurveyCode'
import { IsEnglish } from '../../utils/language';
import { formatDate } from '../../utils';
import { getSurveyList } from '../../actions/survey';

import i18next from 'i18next';
import styles from '../../styles/survey.module.css';

const useStyles = (theme) => ({
    buttons: {
        float: 'left'
    },
    divPeriod: {
        float: 'right'
    },
    spanDay: {
        float: 'left',
        padding: '4px',
        color: '#cfcfcf',
        fontWeight: 'bold'
    },
    spanDayEnabled: {
        color: 'var(--color5)'
    },
    spanNewRow: {
        display: 'table'
    },
    spanLabel: {
        fontWeight: 'bold',
        fontSize: '14px'
    },
    spanValue: {
        marginLeft: '5px',
        fontSize: '14px'
    },
    folder: {
        color: 'var(--color1) !important'
    }
});

class ListSurvey extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            dense: false,
            data: [],
            statusFilter: [],
            isProcessing: false
        }
    }

    componentDidMount() {
        this.loadData();
    }

    handleStatusFilter = (status) => {
        return new Promise(resolve => {
            const statusInt = [];

            if (status[StatusSurvey.Status_Completed] == true) {
                statusInt.push(StatusSurvey.IntStatus_Completed);
            }
            if (status[StatusSurvey.Status_Opened] == true) {
                statusInt.push(StatusSurvey.IntStatus_Opened);
            }
            if (status[StatusSurvey.Status_Expired] == true) {
                statusInt.push(StatusSurvey.IntStatus_Expired);
            }

            this.setState({ ...this.state, statusFilter: statusInt }, () => {
                resolve();
            });
        })
    }

    loadData = async (status) => {
        if (status == null) {
            // Status Opened by default
            status = { "O": true };
        }

        await this.handleStatusFilter(status);

        this.setState({ ...this.state, isProcessing: true }, async () => {
            const response = await getSurveyList();

            if (response != null && response.status == StatusCode.STATUS_OK) {
                const filteredData = response.result?.filter(x => this.state.statusFilter.includes(x.status));

                this.setState({ ...this.state, data: filteredData });
            } else {
                showMessageError(i18next.t('error:generic-error'));
            }
            this.setState({ ...this.state, isProcessing: false });
        });
    }

    handleStatusDescription = (status) => {
        switch (status) {
            case StatusSurvey.IntStatus_Completed:
                return i18next.t('survey:status.completed');
            case StatusSurvey.IntStatus_Expired:
                return i18next.t('survey:status.expired');
            case StatusSurvey.IntStatus_Opened:
                return i18next.t('survey:status.opened');
        }
    }

    handleDetail = (id, description) => {
        this.props.handleDetail(id, description);
    }

    render() {
        const { classes } = this.props;

        return (
            <div className={styles.konekCard}>
                <LoadingLayer isActive={this.state.isProcessing}>
                    <List dense={this.state.dense}>
                        {this.state.data != null && this.state.data.map((obj, index) =>
                            <React.Fragment key={index}>
                                <ListItem key={index} className="listItem" onClick={() => this.handleDetail(obj.employeeSurveyId, `${obj.surveyExerciseCode} - ${IsEnglish() ? obj.descriptionE : obj.descriptionF}`)}>
                                    <ListItemText
                                        primary={
                                            <React.Fragment>
                                                <span className={classes.spanNewRow}>
                                                    <span className={classes.spanLabel}>
                                                        {i18next.t('survey:list.campaign')}{i18next.t('common:labelSeparator')}
                                                    </span>
                                                    <span className={classes.spanValue}>
                                                        {obj.surveyExerciseCode} - {IsEnglish() ? obj.descriptionE : obj.descriptionF}
                                                    </span>
                                                </span>
                                                <span className={classes.spanNewRow}>
                                                    <span className={classes.spanLabel}>
                                                        {i18next.t('survey:labelStatus')}{i18next.t('common:labelSeparator')}
                                                    </span>
                                                    <span className={classes.spanValue}>
                                                        {this.handleStatusDescription(obj.status)}
                                                    </span>
                                                </span>

                                                <span className={classes.spanNewRow}>
                                                    <span className={classes.spanLabel}>
                                                        {i18next.t('survey:list.deadLine')}{i18next.t('common:labelSeparator')}
                                                    </span>
                                                    <span className={classes.spanValue}>
                                                        {formatDate(obj.deadLine, 'date')}
                                                    </span>
                                                </span>
                                                <span className={classes.spanNewRow}>
                                                    <span className={classes.spanLabel}>
                                                        {i18next.t('survey:list.releaseDate')}{i18next.t('common:labelSeparator')}
                                                    </span>
                                                    <span className={classes.spanValue}>
                                                        {formatDate(obj.publicationDate, 'date')}
                                                    </span>
                                                </span>
                                            </React.Fragment>
                                        }
                                    />
                                </ListItem>
                            </React.Fragment>
                        )}
                    </List>
                </LoadingLayer>
            </div>
        )
    }
}

export default withNamespaces(['buttons', 'survey', 'common'], {
    wait: true,
    innerRef: (ref) => {
        ref?.props.setListRef(ref)
    }
})(withStyles(useStyles)(ListSurvey));